import React, { Component, useState } from 'react';
import { connect } from "react-redux";
import { withRouter } from '../../components/Reusable/WithRouter';
import LocationIcon from '../../assets/Svg/LocationIcon';
import CustomerService from '../../services/Customer.service';
import CustomerAction from "../../redux/actions/Customer.action";
import CustomerHeader from "../../components/layout/CustomerHeader"
import CustomerFooter from "../../components/layout/CustomerFooter";
import BackButton from '../../components/Reusable/BackButton';
import config from '../../config/emrok.config';
import Common from '../../hoc/Common.hoc';
import CountryService from '../../services/Country.service';
import Dropdown from '../../components/SearchableDropdown/Dropdown.component';
import OtherService from '../../services/OtherService';
import CustomLoaderComponent from '../../components/CustomLoader/CustomLoader.component';
import { Link } from "react-router-dom";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { Lightbox } from "react-modal-image";
import CallCenterReducer from '../../redux/reducers/CallCenter.reducer';
import DoctorPersonaAction from '../../redux/actions/DoctorPersona.action';
// import { Document, Page, pdfjs } from 'react-pdf';
// const defaultLayoutPluginInstance = defaultLayoutPlugin();
const PdfViewerWithPlugin = ({ pdfFile }) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <Worker workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js`}>
            <Viewer fileUrl={pdfFile} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
    );
};
class RegistrationDetails extends Component {

    constructor(props) {
        super(props)

        this.state = {
            openLightbox: false,
            registration: this.customerRegModel(),
            doctorName: "",
            selectedFile: null,
            fileUploadError: '',
            imagename: "",
            color: 'red',
            age: null,
            isValidAge: false,
            countries: [],
            states: [],
            towns: [],
            statesDoctor: [],
            townsDoctor: [],
            showTowns: false,
            prescription: null,
            isLoading: false,
            isChecked: false,
            selectedFile: [],
            image: null,
            isRegistered: false,
            numPages: null,
            previousCustomerDetails: null,
            loginUseType: "",
            allDoctorList: [],
            filterDoctorList: [],
            dropDownDoctor: [],
            showDropdown: false,
            selectedDoctor: null,
            showLoader: false
        }
        this.fileInputRef = React.createRef();
        this.toggleLightbox = this.toggleLightbox.bind(this);
    }

    // static getDerivedStateFromProps(props, state) {
    //     //console.log(props, "kjdshkjshkd");
    //     return {
    //         prescription: props.CustomerReducer.customer.prescription || null
    //     }
    // }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    };

    toggleLightbox() {
        this.setState(prevState => ({
            openLightbox: !prevState.openLightbox,
        }));
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({ selectedFile: file, fileUploadError: '', imagename: "" }, () => {
                this.handleUpload()
            });
        }
    };

    handleButtonClick = () => {

        // Programmatically trigger the file input click event
        this.fileInputRef.current.click();
    };

    handleUpload = async () => {
        console.log(this.state.isLoading, "loading status");

        const MaxFileSize = 10 * 1024 * 1024; // 10MB in bytes
        // Handle the file upload logic here
        const { selectedFile } = this.state;

        console.log(selectedFile);

        if (selectedFile) {
            this.setState({ isLoading: true });
            const fileType = selectedFile.type;
            const fileSizeMB = selectedFile.size / (1024 * 1024);
            if (fileType !== 'image/jpeg' && fileType !== 'image/png' && fileType !== 'application/pdf') {

                this.setState({ isLoading: false });
                this.setState({ fileUploadError: 'Only JPG, PNG, and PDF files are allowed.', color: "red" });

                return;
            }
            else if (fileSizeMB > 25) {
                this.setState({ isLoading: false });
                this.setState({ fileUploadError: 'File size must be less than 25MB.', color: "red" });

                return;
            }
            else {
                const reader = new FileReader()
                // reader.onloadend = () => {
                //     console.log(reader, 7777)
                //     this.setState({ image: reader.result })
                // }
                reader.onload = (e) => {
                    this.setState({ image: e.target.result });
                };
                reader.readAsDataURL(selectedFile)
                // let newFile = await new File([file], this.state.product._id + '.' + file.name.split('.')[file.name.split('.').length - 1], { type: file.type })
                // this.setState({ selectedFile: newFile, fileUploadError: '', imagename: '' }, () => {
                //     // this.handleUpload()
                // });

                let payload = new FormData()
                // payload.append("customer_id", this.props.customer._id || null)
                // payload.append("doctor_id", this.props.customer.prescribedDoctor._id || null)
                payload.append("prescription", selectedFile)

                // console.log(selectedFile, 66666);

                this.setState({ fileUploadError: 'Prescription uploaded', color: "green", imagename: selectedFile.name, selectedFile: selectedFile });
                //console.log('File to upload:', selectedFile, this.props.customer, payload);
                // CustomerService.uploadPrescription(payload).then(data => {
                //     console.log(data.data.data.filepath, "data !!!!!!!!!!!!file pathh");
                //     this.getPrescription()
                //     this.setState({ isLoading: false });
                //     this.setState({ fileUploadError: 'Prescription uploaded', color: "green", imagename: data.data.data.filepath });
                // }).catch(err => {
                //     this.setState({ isLoading: false });
                //     console.log(err, "err")
                // })
            }
        } else {
            this.setState({ fileUploadError: 'Please select a file first.' });
        }
    };

    customerRegModel = (data = { address: {} }) => {
        if (data.address == null) {
            data.address = {};
        }
        const obj = {
            name: data.name ? data.name : "",
            address: {
                _id: data.address ? data.address._id : null,
                country: data.address.country ? data.address.country : "",
                addressLine1: data.address.addressLine1 ? data.address.addressLine1 : "",
                addressLine2: data.address.addressLine2 ? data.address.addressLine2 : "",
                town: data.address.town ? data.address.town : "",
                state: data.address.state ? data.address.state : "",
                pin: data.address.pin ? data.address.pin : "",
            },
            age: data.age ? data.age : "",
            email: data.email ? data.email : "",
            mobileno: data.mobileno ? data.mobileno : "",
            gender: data.gender ? data.gender : "",
            patientAddressLine1: data.address.patientAddressLine1 ? data.address.patientAddressLine1 : "",
            patientAddressLine2: data.address.patientAddressLine2 ? data.address.patientAddressLine2 : "",
            patientCountry: data.address.patientCountry ? data.address.patientCountry : "",
            patientState: data.address.patientState ? data.address.patientState : "",
            patientTown: data.address.patientTown ? data.address.patientTown : "",
            patientPin: data.address.patientPin ? data.address.patientPin : "",
            drName: data.drName ? data.drName : "",
            drRegistrationNo: data.drRegistrationNo ? data.drRegistrationNo : "",
            drCode: data.drCode ? data.drCode : "",
            drPin: data.drPin ? data.drPin : "",
            drmobileno: data.drmobileno ? data.drmobileno : "",
            drState: data.drState ? data.drState : "",
            drCity: data.drCity ? data.drCity : "",
            consent: data.consent ? data.consent : false,
            prescription: data.prescription
        }
        return { ...obj }
    }


    componentDidMount() {
        // alert('registration')
        // return

        const doctorPersonaDetails = this.props.doctorPersonaDetails;
        console.log(doctorPersonaDetails, "doctorPersonaDetails");
        if (!doctorPersonaDetails || Object.keys(doctorPersonaDetails).length === 0) {
            console.log("doctorPersonaDetails is blank or empty.");
        } else {
            console.log("doctorPersonaDetails is not blank.");
            this.setState({ loginUseType: 'doctorpersona' })
        }
        // if (doctorPersonaDetails) {
        //     console.log("doctorPersonaDetails123")
        //     this.setState({ loginUseType: 'doctorpersona' })
        // }
        console.log(doctorPersonaDetails, "doctorPersonaDetails");
        const adminLoginDetails = this.props.admin;
        const callcenterLoginDetails = this.props.callcenterdetails;
        console.log(adminLoginDetails, callcenterLoginDetails, "adminLoginDetails");
        console.log("Current location11:", this.props.location);
        console.log('1402');
        CountryService.getCountries().then(data => {
            //console.log(data, "countries")
            if (data.success) {
                this.setState({ countries: data.countries })
            }
        })
        const customer = this.props.customer;
        console.log(customer, 5555);
        //console.log(this.customerRegModel(customer), customer, 89347298379823474)
        console.log(this.state.prescription, "popopopopo")
        if (this.state.prescription) this.getPrescription()

        this.setState({
            registration: customer ? this.customerRegModel(customer) : this.customerRegModel(),
            doctorName: ""

        }, async () => {
            let registration = await this.state.registration
            registration["address"]["country"] = "India"
            await this.setState({ registration })
            setTimeout(() => {
                this.populateStates("IN")
                this.populateStatesDoctor("IN")
                // this.populateStates(countryObj.isoCode)
            }, 500);
            // }
        })
        this.setState({ isChecked: customer ? customer.consent : false, previousCustomerDetails: customer });
        if (customer.prescription) {
            this.setState({ image: `${config.serviceUrl}/pres-images/${customer.prescription.filepath}`, imagename: customer.prescription.filepath })
        }
        console.log(customer.name, 999);
        this.getAllWockhardtDoctorList();
        this.setState({ isRegistered: (customer.name !== undefined && customer.name !== "") });
    }


    // getPrescription = () => {
    //     const customer = this.props.customer;
    //     let customer_id = customer._id || null
    //     let doctor_id = customer.prescribedDoctor._id || null
    //     //console.log(customer_id, doctor_id, customer, 4444444);
    //     if (customer_id && doctor_id) {
    //         CustomerService.getPrescription({ customer_id, doctor_id }).then(data => {
    //             //console.log(data, "getPrescription");
    //             if (data.success) {
    //                 let prescription = this.state.prescription
    //                 if (prescription) {
    //                     this.setState({ fileUploadError: 'Prescription uploaded', color: "green", imagename: prescription.filepath || "", selectedFile: true });
    //                 }
    //             }
    //         })
    //     }
    // }

    getAllWockhardtDoctorList = () => {
        const { registration } = this.state
        const id = `divsn00000000000000000000002024041501`;  // Replace with your dynamic ID
        const url = `https://infinityplus.wockhardt.com/plus/reports/customer/dml/${id}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'S09TiRym+PcZQaggzeT0e7VOPKCaEvA5lMuvQ98j79qPz1oZD1pKnqtlAnpT2Fkz9mWA8en1An2SbtGSarF0ZF82sW4nnOHNMFPPiZ6zhwjTGMgx9KsqV3f/398WYzltTe2uSDg0tErjM5XpR4HsQw==',  // Replace with your token
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log(data, 'doctorData');
                if (data.length > 0) {
                    console.log(registration.drPin, "customer123")
                    if (registration.drPin != "") {
                        const filteredData = data.filter(item => item.pinCode === registration.drPin);
                        console.log(filteredData, "filteredData2222");
                        const distinctDoctors = filteredData.reduce((map, item) => {
                            const trimmedDoctorName = item.doctorName.trim();
                            const key = `${item.doctorUid}-${trimmedDoctorName}-${item.mobile}-${item.pinCode}-${item.state}-${item.town}`;
                            if (!map.has(key)) {
                                map.set(key, item);
                            }
                            return map;
                        }, new Map());
                        const distinctDoctorList = Array.from(distinctDoctors.values());
                        this.setState({ showLoader: false, dropDownDoctor: distinctDoctorList, allDoctorList: data })
                    } else {
                        // this.props.setDoctorList(data);
                        this.setState({ allDoctorList: data })
                    }


                }
                // Handle the data received
            })
            .catch(error => {
                console.error('Error:', error);
            });
        // CustomerService.getWockhardtDoctor().then(data => {
        //     console.log(data, "getWockhardtDoctor")
        //     if (data.success) {
        //         // this.setState({ allDoctorList: data.countries })
        //     }
        // })
    }

    changeVal = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const registration = { ...this.state.registration };
        registration[name] = value;
        this.setState({ registration: registration });
    }

    changeValDoctorName = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        // alert(name);
        // alert(value);
        const registration = { ...this.state.registration };
        registration[name] = value;
        this.setState({ registration: registration });
        const filteredList = this.state.filterDoctorList.filter((doctor) =>
            doctor.doctorName.toLowerCase().includes(value.toLowerCase())
        );
        console.log(filteredList, "filteredList");
        this.setState({
            dropDownDoctor: filteredList, // Update the filtered list
            showDropdown: true
        });
    }

    changeValDoctor = async (event) => {
        const { allDoctorList } = this.state
        const name = event.target.name;
        const value = event.target.value;
        const registration = { ...this.state.registration };
        registration[name] = value;
        this.setState({ registration: registration });
        if (allDoctorList.length > 0) {
            if (value.toString().length > 5) {
                const filteredData = allDoctorList.filter(item => item.pinCode === value);
                // Get distinct results
                const distinctDoctors = filteredData.reduce((map, item) => {
                    const trimmedDoctorName = item.doctorName.trim();
                    const key = `${item.doctorUid}-${trimmedDoctorName}-${item.mobile}-${item.pinCode}-${item.state}-${item.town}`;
                    if (!map.has(key)) {
                        map.set(key, item);
                    }
                    return map;
                }, new Map());

                // Convert the Map back to an array
                const distinctDoctorList = Array.from(distinctDoctors.values());

                console.log(distinctDoctorList, "distinctDoctorList");
                console.log(filteredData, "filteredData");

                this.setState({ filterDoctorList: distinctDoctorList })
            }



        }
    }

    selectOption = (doctor) => {

        const registration = { ...this.state.registration };
        registration['drName'] = doctor.doctorName;
        if (doctor) {
            registration['drmobileno'] = doctor.mobile;
            registration['drCode'] = doctor.doctorCode;
        }

        console.log(doctor, "doctor12344");
        this.setState({ registration: registration });
        this.setState({
            // Set the selected option in input
            selectedDoctor: doctor,
            showDropdown: false // Close dropdown
        });
    };

    toggleDropdown = () => {
        this.setState({ showLoader: true, dropDownDoctor: [] });
        this.setState((prevState) => ({
            showDropdown: !prevState.showDropdown,
            // Update the filtered list
            // showDropdown: true
        }));
        this.getAllWockhardtDoctorList();
    };

    componentDidUpdate(prevProps) {
        if (prevProps.customer !== this.props.customer) {
            const customer = this.props.customer;
            this.setState({
                registration: customer ? this.customerRegModel(customer) : this.customerRegModel(),
                doctorName: customer.prescribedDoctor ? customer.prescribedDoctor.name : ""
            })
        }
    }


    changeAddr = (event) => {

        const name = event.target.name;
        const value = event.target.value;

        if (name == 'pin' && value.length == 6) {
            let payload = {
                pincode: value
            }
            console.log(payload, "payload123");
            OtherService.getStateAndCity(payload).then(async res => {

                console.log(res.data.data.details, "getStateAndCity");
                if (res && res.data && res.data.success) {

                    let _registration = this.state.registration
                    _registration.address["state"] = res.data.data.details.stateName
                    _registration.address["town"] = res.data.data.details.cityName
                    this.setState({ registration: _registration })

                    setTimeout(() => {
                        this.populateStates("IN")
                        this.populateTowns(res.data.data.details.countryCode, res.data.data.details.isoCode)
                    }, 500);

                }
            }).catch(err => {
                //console.log(err)
            })

        } else if (name == 'pin' && value.length == 0) {
            let _registration = this.state.registration
            _registration.address["state"] = ""
            _registration.address["town"] = ""
            this.setState({ registration: _registration })

            setTimeout(() => {
                this.populateStates("IN")
                // this.populateTowns(res.data.data.details.countryCode, res.data.data.details.isoCode)
            }, 500);

        }

        const address = { ...this.state.registration.address };
        address[name] = value;
        this.setState({ registration: { ...this.state.registration, address: { ...address } } });
    }
    // Function to fetch PDF from URL and convert to Base64
    fetchPdfAndConvertToBase64 = async (url) => {
        try {
            console.log(url, 88888999);
            const response = await fetch(url, { mode: 'no-cors' });
            const blob = await response.blob(); // Get the PDF as a Blob

            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({ base64: reader.result }); // Base64 string
            };

            reader.readAsDataURL(blob); // Convert Blob to base64
        } catch (error) {
            console.error('Error fetching PDF:', error);
        }
    };

    next = (type = null) => {
        const { location } = this.props
        let userType = location.pathname.includes("callcenter") ? 'callcenter' : 'admin';
        const doctorPersonaDetails = this.props.doctorPersonaDetails;
        console.log(doctorPersonaDetails, "doctorPersonaDetails");
        if (Object.keys(doctorPersonaDetails).length > 0) {
            console.log(doctorPersonaDetails, "userType1")
            userType = 'doctorpersona';
        }
        // console.log(location.pathname, "pathname");
        // return
        const addressLine1 = this.state.registration.address.addressLine1;
        const country = this.state.registration.address.country == "India" ? "India" : "India";
        const state = this.state.registration.address.state;
        const pin = this.state.registration.address.pin;
        const town = this.state.registration.address.town;
        const name = this.state.registration.name;
        const age = this.state.registration.age;
        const gender = this.state.registration.gender;
        const email = this.state.registration.email;
        const patientAddressLine1 = this.state.registration.address.patientAddressLine1;
        const patientPin = this.state.registration.address.patientPin;
        const patientState = this.state.registration.address.patientState;
        const patientTown = this.state.registration.address.patientTown;
        const drName = this.state.registration.drName;
        const drPin = this.state.registration.drPin;
        const drState = this.state.registration.drState;
        const drCity = this.state.registration.drCity;
        const drRegistrationNo = this.state.registration.drRegistrationNo;
        const drCode = this.state.registration.drCode;
        const drMobileno = this.state.registration.drmobileno;
        //console.log('dvdfbbgnghmnhjgfkl>>>>>>>>>>>', this.state)
        const { image } = this.state
        // console.log(image, 6666000)
        // return
        console.log(pin.toString().length, "pinnnn");
        if (email && email !== "") {
            if (!this.props.hoc.verifyEmail(email)) {
                this.props.hoc.customAlert('Please provide a valid email.', false)
                return false
            }
        }
        if (!name && name == "") {
            this.props.hoc.customAlert('Name is required.', false)
            return false
        } else if (!age && age == "") {
            this.props.hoc.customAlert('Age is required.', false)
            return false
        }
        // else if (age < 18) this.props.hoc.customAlert("Age must be greater than or equal to 18", false)
        else if (!gender && gender == "") {
            this.props.hoc.customAlert('Gender is required.', false)
            return false
        } else if (!addressLine1 && addressLine1 == "") {
            this.props.hoc.customAlert('Address is required.', false)
            return false
        } else if (!pin && pin == "") {
            this.props.hoc.customAlert('Pin Code is required.', false)
            return false
        }
        else if (pin && pin.toString().length < 6) {
            this.props.hoc.customAlert('Pin Code must be 6 digits.', false)
            return false
        }
        else if (!country && country == "") {
            this.props.hoc.customAlert('Country is required.', false)
            return false
        }
        else if (!state && state == "") {
            this.props.hoc.customAlert('State is required.', false)
            return false
        }
        else if (!town && town == "") {
            this.props.hoc.customAlert('City/Town is required.', false)
            return false
        }
        else if (image == null || image == false) {
            this.props.hoc.customAlert("Please upload prescription", false)
        } else if (drState == "") {
            this.props.hoc.customAlert('Doctor State is required.', false)
            return false
        } else if (drCity == "") {
            this.props.hoc.customAlert('Doctor City is required.', false)
            return false
        }
        else if (drName == "") {
            this.props.hoc.customAlert('Doctor Name is required.', false)
            return false
        } else if (drMobileno == "" || (drMobileno.toString().length < 10)) {
            this.props.hoc.customAlert('Doctor Mobile Number is required.', false)
            return false
        } else if (drRegistrationNo == "") {
            this.props.hoc.customAlert('Doctor Registration Number is required.', false)
            return false
        } else if (drPin == "") {
            this.props.hoc.customAlert('Doctor Pin Code is required.', false)
            return false
        }
        else if (this.state.isChecked == false || this.state.isChecked == null) {

            this.props.hoc.customAlert('Please check consent checkbox.', false)
            return false
        }
        else {

            let oldValuKey = [];
            //console.log('test 135465874>>>>>>>>>>>>>>>>>>>>>')
            const { registration, prescription, selectedFile, previousCustomerDetails } = this.state;
            let current_data = Object.entries(registration)
            console.log(current_data, 'current_data', current_data.length);
            for (let i = 0; i < current_data.length; i++) {
                console.log(current_data[i], current_data[i][0], current_data[i][1], 9999999);
                console.log(previousCustomerDetails, "previousCustomerDetails")
                console.log(current_data[i][1], previousCustomerDetails[current_data[i][0]], "previousCustomerDetails123")
                if (current_data[i][1] != previousCustomerDetails[current_data[i][0]]) {
                    if (current_data[i][0] != "address") {
                        oldValuKey.push({ [current_data[i][0]]: previousCustomerDetails[current_data[i][0]] });
                    }
                    console.log("ok", i, current_data[i][1]);
                    if (current_data[i][0] === "address") {
                        let address_data = Object.entries(registration.address);
                        for (let j = 0; j < address_data.length; j++) {
                            if (address_data[j][1] != previousCustomerDetails[current_data[i][0]][address_data[j][0]]) {
                                oldValuKey.push({ [address_data[j][0]]: previousCustomerDetails[current_data[i][0]][address_data[j][0]] });
                                console.log(address_data[j][0], previousCustomerDetails[current_data[i][0]][address_data[j][0]], "address_data_key");
                            }
                        }
                        console.log(address_data, "address_data");
                    }
                }
            }
            console.log(oldValuKey, "oldValuKey")
            // return
            console.log(this.props.customer, 66666);

            const id = this.props.customer._id;
            let detailsCustomer = {
                customer_id: id,
                doctor_id: null,
            };
            // console.log(this.props.CallCenterReducer, "CallCenterReducer");
            // return
            let _registration = { ...registration, doctor_id: null, buttonType: 'next' }
            console.log(_registration, id, prescription, 898900);
            let oldValueKey = this.props.customer;
            const adminLoginDetails = this.props.admin;
            const callcenterLoginDetails = this.props.callcenterdetails;
            let callcenter_id = null
            if (userType == 'callcenter') {
                callcenter_id = callcenterLoginDetails._id
            } else if (userType == 'doctorpersona') {
                callcenter_id = doctorPersonaDetails._id
            } else {
                callcenter_id = adminLoginDetails._id
            }
            console.log(userType, "userType");
            // return
            console.log(_registration, "_registration123");
            // return
            console.log(callcenter_id, "callcenter_id");
            // return
            CustomerService.updateCustomer({ registration: _registration, oldValuKey, id, type: userType, callcenter_id: callcenter_id }).then(async res => {
                console.log(res, 5588888);
                if (res && res.data && res.data.success && res.data.data) {
                    console.log(res, 66666999999);
                    // return
                    let customer = res.data.data.customer
                    const prescriptionLength = customer[0].prescription ? customer[0].prescription.length : null;
                    const allPrescription = customer[0].prescription ? customer[0].prescription[prescriptionLength - 1] : null
                    let customerDetailsObjNew = {
                        _id: customer[0].customer._id,
                        customer_code: null,
                        country_code: "+91",
                        mobileno: customer[0].customer.mobileno,
                        age: customer[0].customer.age,
                        email: customer[0].customer.email,
                        gender: customer[0].customer.gender,
                        name: customer[0].customer.name,
                        drName: customer[0].doctors ? customer[0].doctors.drName : "",
                        drRegistrationNo: customer[0].doctors ? customer[0].doctors.drRegNo : "",
                        drCode: customer[0].doctors ? customer[0].doctors.drCode : "",
                        drPin: customer[0].doctors ? customer[0].doctors.pin : "",
                        drmobileno: customer[0].doctors ? customer[0].doctors.mobileno : "",
                        drState: customer[0].doctors ? (customer[0].doctors.drState ? customer[0].doctors.drState : "") : "",
                        drCity: customer[0].doctors ? (customer[0].doctors.drCity ? customer[0].doctors.drCity : "") : "",
                        address: {
                            _id: customer[0].address ? customer[0].address._id : "",
                            country: customer[0].address ? customer[0].address.country : "",
                            addressLine1: customer[0].address ? customer[0].address.addressLine1 : "",
                            addressLine2: customer[0].address ? customer[0].address.addressLine2 : "",
                            town: customer[0].address ? customer[0].address.town : "",
                            state: customer[0].address ? customer[0].address.state : "",
                            pin: customer[0].address ? customer[0].address.pin : "",
                        },
                        doctor_id: customer[0].doctors ? customer[0].doctors._id : "",
                        consent: customer[0].customer.consent ? customer[0].customer.consent : false,
                        prescription: allPrescription,
                        order_id: this.props.customer.order_id
                    };

                    console.log(customerDetailsObjNew, 6666);
                    this.setState({
                        registration: this.customerRegModel(customerDetailsObjNew)
                    })
                    this.setState({ isChecked: customer[0].customer.consent });
                    console.log(customerDetailsObjNew, 6666);

                    const adminDetails = this.props.admin;
                    const callcenterDetails = this.props.callcenterdetails;
                    const doctorDetails = this.props.doctorPersonaDetails;
                    let callcenterid = null
                    if (userType == 'callcenter') {
                        callcenterid = callcenterDetails._id
                    } else if (userType == 'doctorpersona') {
                        callcenterid = doctorDetails._id
                    } else {
                        callcenterid = adminDetails._id
                    }

                    // console.log(callcenterid, "callcenterid");
                    // return
                    let payload = new FormData()
                    payload.append("customer_id", customer[0].customer._id || null)
                    payload.append("doctor_id", customer[0].doctors ? customer[0].doctors._id : null)
                    payload.append("order_id", this.props.customer.order_id)
                    payload.append("prescription", selectedFile)
                    payload.append("pagename", 'edit_registration')
                    payload.append("userType", userType)
                    payload.append("loginUserId", callcenterid)

                    CustomerService.uploadPrescriptionUpdateOrder(payload).then(data => {
                        // console.log(data.data.data.filepath, "data !!!!!!!!!!!!file pathh");

                        this.setState({ isLoading: false });

                    }).catch(err => {
                        this.setState({ isLoading: false });
                        console.log(err, "err")
                    })
                    // OtherService.getCustomerOut().then(async res => {
                    //     if (res && res.data && res.data.success) {

                    //     }
                    // }).catch(err => {
                    //     //console.log(err)
                    // })
                    // OtherService.getCustomerDetailsOut(detailsCustomer).then(res => {
                    //     if (res && res.data && res.data.success) {
                    //         console.log(res, "response from customer out");
                    //     }
                    // }).catch(err => {
                    //     //console.log(err)
                    // })
                    this.props.setCustomer(customerDetailsObjNew);
                    this.props.hoc.customAlert('Your registration details is updated.', true, "", false, false, async () => {
                        this.setState({ isRegistered: true });
                        this.props.navigate(-1)
                    }, () => {
                    })
                }
            }).catch(e => {
                //console.log(e)
            })
        }
    }

    populateStates = (isoCode = null) => {
        if (isoCode) {
            CountryService.getStates(isoCode).then(data => {
                //console.log(data, "states")
                if (data.success) {
                    this.setState({ states: data.states, towns: [] }, async () => {
                        this.setState({ showTowns: false })
                        let _state = this.state.registration.address.state || null
                        console.log(_state, this.state.states, "jhgjhgjhg");
                        if (_state) {
                            let stateObj = null
                            for (let i = 0; i < this.state.states.length; i++) {
                                if (this.state.states[i].name === _state) {
                                    stateObj = this.state.states[i]
                                }
                            }
                            console.log(stateObj, _state, 1234545677);
                            console.log("stateObj found", stateObj)
                            // if (stateObj) {
                            setTimeout(() => {
                                this.populateTowns(stateObj.countryCode, stateObj.isoCode)
                            }, 500);
                            // }
                        }
                    })
                }
            })
        }
    }

    populateTowns = (countryCode = null, stateCode = null) => {
        console.log(countryCode, stateCode, "countryCode stateCode")
        if (countryCode && stateCode) {
            CountryService.getTowns(countryCode, stateCode).then(data => {
                console.log(data, "towns")
                // setTimeout(() => {
                if (data.success) {
                    this.setState({ towns: data.towns }, () => this.setState({ showTowns: true }))
                }
                // }, 2000);
            })
        }
    }

    populateStatesDoctor = (isoCode = null) => {
        if (isoCode) {
            CountryService.getStates(isoCode).then(data => {
                //console.log(data, "states")
                if (data.success) {
                    this.setState({ statesDoctor: data.states, townsDoctor: [] }, async () => {
                        this.setState({ showTownsDoctor: false })
                        let _state = this.state.registration.drState || null
                        console.log(_state, this.state.statesDoctor, "jhgjhgjhg");
                        if (_state) {
                            let stateObj = null
                            for (let i = 0; i < this.state.statesDoctor.length; i++) {
                                if (this.state.statesDoctor[i].name === _state) {
                                    stateObj = this.state.statesDoctor[i]
                                }
                            }
                            console.log(stateObj, _state, 1234545677);
                            console.log("stateObj found", stateObj)
                            // if (stateObj) {
                            setTimeout(() => {
                                this.populateTownsDoctor(stateObj.countryCode, stateObj.isoCode)
                            }, 500);
                            // }
                        }
                    })
                }
            })
        }
    }

    populateTownsDoctor = (countryCode = null, stateCode = null) => {
        console.log(countryCode, stateCode, "countryCode stateCode")
        if (countryCode && stateCode) {
            CountryService.getTowns(countryCode, stateCode).then(data => {
                console.log(data, "towns")
                // setTimeout(() => {
                if (data.success) {
                    this.setState({ townsDoctor: data.towns }, () => this.setState({ showTownsDoctor: true }))
                }
                // }, 2000);
            })
        }
    }

    handleOrderHistory = () => {

        const customer = this.props.customer;

        if (customer) {

            let details = {
                customer_id: customer._id
            }
            try {
                CustomerService.getOrders(details).then(res => {
                    if (res && res.data && res.data.success && res.data.data) {
                        if (res.data.data.order.length > 0) {
                            // this.props.navigate('/customer/track-order')
                            // this.props.saveAllOrder(res.data.data.order);
                            this.props.navigate('/orders')
                        } else {

                            this.props.hoc.customAlert("You don't have any past orders. If you have already registered,  please click the 'Place Order' button to order now.", false);
                        }

                        console.log(res.data.data.order, "order details");

                    } else {

                        this.props.hoc.customAlert("You don't have any past orders. If you have already registered,  please click the 'Place Order' button to order now.", false);
                    }

                })
            } catch (error) {
                console.log(error);
            }
        } else {
        }
        // this.props.navigate('/customer/orders');
    }

    handleConsentCheckbox = () => {
        const currentVal = !this.state.isChecked
        this.setState({ isChecked: currentVal });
        this.props.setConsentCheckbox(currentVal);
        const registration = { ...this.state.registration };
        registration['consent'] = currentVal;
        this.setState({ registration: registration });

    }

    handleNext = () => {
        const drName = this.state.registration.drName;
        const drPin = this.state.registration.drPin;
        const drRegistrationNo = this.state.registration.drRegistrationNo;
        const drCode = this.state.registration.drCode;
        const drMobileno = this.state.registration.drmobileno;
        const drState = this.state.registration.drState;
        const drCity = this.state.registration.drCity;
        const { image } = this.state
        if (drState == "") {
            this.props.hoc.customAlert('Doctor State is required.', false)
            return false
        } else if (drCity == "") {
            this.props.hoc.customAlert('Doctor City is required.', false)
            return false
        } else if (image == null || image == false) {
            this.props.hoc.customAlert("Please upload prescription", false)
        } else if (drName == "") {
            this.props.hoc.customAlert('Doctor Name is required.', false)
            return false
        } else if (drMobileno == "" || (drMobileno.toString().length < 10)) {
            this.props.hoc.customAlert('Doctor Mobile Number is required.', false)
            return false
        } else if (drRegistrationNo == "") {
            this.props.hoc.customAlert('Doctor Registration Number is required.', false)
            return false
        } else if (drPin == "") {
            this.props.hoc.customAlert('Doctor Pin Code is required.', false)
            return false
        }

        else if (this.state.isChecked == false || this.state.isChecked == null) {

            this.props.hoc.customAlert('Please check consent checkbox.', false)
            return false
        }
        else {
            console.log(this.state.isChecked);
            const { registration, prescription, selectedFile } = this.state;
            const id = this.props.customer._id;
            let detailsCustomer = {
                customer_id: id,
                doctor_id: null,
            };
            let _registration = { ...registration, doctor_id: null, buttonType: 'next' }
            console.log(_registration, id, prescription, 898900);
            CustomerService.updateCustomer({ registration: _registration, id }).then(async res => {
                console.log(res, 5588888);
                if (res && res.data && res.data.success && res.data.data) {
                    console.log(res, 66666999999);
                    // return
                    let customer = res.data.data.customer
                    const prescriptionLength = customer[0].prescription ? customer[0].prescription.length : null;
                    const allPrescription = customer[0].prescription ? customer[0].prescription[prescriptionLength - 1] : null
                    let customerDetailsObjNew = {
                        _id: customer[0].customer._id,
                        customer_code: null,
                        country_code: "+91",
                        mobileno: customer[0].customer.mobileno,
                        age: customer[0].customer.age,
                        email: customer[0].customer.email,
                        gender: customer[0].customer.gender,
                        name: customer[0].customer.name,
                        drName: customer[0].doctors ? customer[0].doctors.drName : "",
                        drRegistrationNo: customer[0].doctors ? customer[0].doctors.drRegNo : "",
                        drCode: customer[0].doctors ? customer[0].doctors.drCode : "",
                        drPin: customer[0].doctors ? customer[0].doctors.pin : "",
                        drmobileno: customer[0].doctors ? customer[0].doctors.mobileno : "",
                        drState: customer[0].doctors ? (customer[0].doctors.drState ? customer[0].doctors.drState : "") : "",
                        drCity: customer[0].doctors ? (customer[0].doctors.drCity ? customer[0].doctors.drCity : "") : "",
                        address: {
                            _id: customer[0].address ? customer[0].address._id : "",
                            country: customer[0].address ? customer[0].address.country : "",
                            addressLine1: customer[0].address ? customer[0].address.addressLine1 : "",
                            addressLine2: customer[0].address ? customer[0].address.addressLine2 : "",
                            town: customer[0].address ? customer[0].address.town : "",
                            state: customer[0].address ? customer[0].address.state : "",
                            pin: customer[0].address ? customer[0].address.pin : "",
                        },
                        doctor_id: customer[0].doctors ? customer[0].doctors._id : "",
                        consent: customer[0].customer.consent ? customer[0].customer.consent : false,
                        prescription: allPrescription
                    };

                    console.log(customerDetailsObjNew, 6666);
                    this.setState({
                        registration: this.customerRegModel(customerDetailsObjNew)
                    })
                    this.setState({ isChecked: customer[0].customer.consent });
                    console.log(customerDetailsObjNew, 6666);
                    let payload = new FormData()
                    payload.append("customer_id", customer[0].customer._id || null)
                    payload.append("doctor_id", customer[0].doctors ? customer[0].doctors._id : null)
                    payload.append("order_id", id)
                    payload.append("prescription", selectedFile)

                    CustomerService.uploadPrescriptionUpdateOrder(payload).then(data => {
                        console.log(data.data.data.filepath, "data !!!!!!!!!!!!file pathh");

                        this.setState({ isLoading: false });

                    }).catch(err => {
                        this.setState({ isLoading: false });
                        console.log(err, "err")
                    })

                    this.props.setCustomer(customerDetailsObjNew);
                    let pagename = 'Registration';
                    this.props.setPagename(pagename)
                    this.props.navigate('/place-order')

                }
            }).catch(e => {
                //console.log(e)
            })
        }
    }

    handleBlurEvent = (event) => {

        const name = event.target.name;
        const value = event.target.value;
        const payload = {
            pincode: value
        };
        CustomerService.checkPincodeAvailablity(payload).then(data => {
            console.log(data, 'pincodedata');
            if (data.data.data.details) {
                console.log(data, 'pincodedata');

            } else {
                this.props.hoc.customAlert('Delivery not available in this pin code.', false)
            }
        })
    }
    setNumber = (event) => {
        const val = event.target.value;
        const { registration } = this.state
        const { mobileno, drmobileno } = registration
        const reg = new RegExp('^[0-9]+$');
        if (!val || (reg.test(val) && val.length <= 10)) {
            const name = event.target.name;
            const value = event.target.value;

            if (mobileno != '' && mobileno == value) {
                this.props.hoc.customAlert("Patient and Doctor mobile number cannot be same", false);
                const registration = { ...this.state.registration };
                registration[name] = "";
                this.setState({ registration: registration });
                return false
            } else {
                const registration = { ...this.state.registration };
                registration[name] = value;
                this.setState({ registration: registration });
            }


        }
    }

    goBackPrevious = () => {
        this.props.navigate(-1);
        // this.props.navigate('/admin/order-managment');
    };
    render = () => {
        const { fileUploadError, color, registration, imagename, countries, states, towns, isLoading, showTowns, image, isRegistered, numPages, openLightbox, loginUseType, filterDoctorList, showDropdown, dropDownDoctor, statesDoctor, townsDoctor, showTownsDoctor } = this.state;
        console.log(loginUseType, "loginUseType")
        console.log(registration, 'registration');
        console.log(isRegistered, "isRegistered");
        console.log(imagename, "imagename");
        console.log(image, "image");
        const { name, address, age, email, gender, mobileno, drName, drRegistrationNo, drPin, prescription, drmobileno, drState, drCity } = registration;
        const { country, addressLine1, addressLine2, pin, town, state, patientAddressLine1, patientAddressLine2, patientPin, patientCountry, patientState, patientTown } = address
        const { doctorName } = this.state;
        const { isChecked } = this.state;
        console.log(isChecked, 2555);
        const isCheckedConsent = this.props.customer.consentValue;
        console.log(this.props.customer, 66666);

        console.log(prescription, 99999)
        console.log(isCheckedConsent, "isCheckedConsent", showTowns, town, state)
        //console.log(this.state, '>>>>>>>>>>>>>>>>>')
        return (
            <div>

                {/*myown-login-part-start-----*/}
                <section className="regstr-form">
                    <div className="container">
                        <CustomerHeader />

                        <div className="reg-frm-dta align-items-center">
                            <div className="reg-text-ft"><h3>Patient Information</h3></div>
                            <div className="know-more-text mb-0">

                            </div>
                        </div>
                        <form className="mt-3 registration-form">
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Name <span className='requiredFld'> * </span></label>
                                    <input type="text" value={name} name="name" onChange={(event) => this.changeVal(event)} id className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} />
                                </div>
                                <div className="col-md-1 mb-3 for-apper-pt">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">Age <span className='requiredFld'> * </span></label>
                                    <input type="number" value={age} onInput={(e) => e.target.value = e.target.value.slice(0, 2)} onChange={this.changeVal} name='age' className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} placeholder="Select age" />
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label htmlFor className="form-label cls-gndr lvl-clr-hd">Gender <span className='requiredFld'> * </span></label>
                                    <select className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} value={gender} onChange={(event) => this.changeVal(event)} name="gender" >
                                        <option value="" disabled selected hidden>Please Select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="others">Others</option>
                                    </select>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Email</label>
                                    <input type="text" value={email} name="email" onChange={(event) => this.changeVal(event)} id className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} placeholder />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">Mobile Number <span className='requiredFld'> * </span>
                                    </label>
                                    <input type="text" readOnly={true} value={mobileno} onChange={(event) => this.changeVal(event)} name="mobileno" id className={`form-control inpt_brdr_colr field-readonly`} placeholder />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-10 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Address <span className='requiredFld'> * </span></label>
                                    <input type="text" value={addressLine1} onChange={(event) => this.changeAddr(event)} name='addressLine1' id className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} placeholder />
                                </div>
                                <div className="col-md-2 mb-3 for-apper-pt">
                                    <label htmlFor className="form-label lvl-clr-hd">Pin Code <span className='requiredFld'> * </span></label>
                                    <input type='number' onInput={(e) => e.target.value = e.target.value.slice(0, 6)} value={pin} onChange={(event) => this.changeAddr(event)} name="pin" id className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} placeholder />
                                </div>
                            </div>
                            <div className="row">

                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">Country <span className='requiredFld'> * </span></label>
                                    {
                                        countries.length &&
                                        <Dropdown
                                            items={countries}
                                            onSelect={(item) => {
                                                if (item) {
                                                    let _registration = this.state.registration
                                                    _registration.address["country"] = item.name
                                                    _registration.address["state"] = ""
                                                    _registration.address["town"] = ""
                                                    this.setState({ registration: _registration })
                                                    //console.log(item, "item");
                                                    this.populateStates(item.isoCode)
                                                }
                                            }}
                                            value={country}
                                            isDisabled={true}
                                        />
                                    }

                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">State <span className='requiredFld'> * </span></label>
                                    {
                                        states.length ?
                                            <Dropdown
                                                items={states}
                                                onSelect={(item) => {
                                                    if (item) {
                                                        let _registration = this.state.registration
                                                        _registration.address["state"] = item.name
                                                        _registration.address["town"] = ""
                                                        this.setState({ registration: _registration })
                                                        //console.log(item, "item");
                                                        this.populateTowns(item.countryCode, item.isoCode)
                                                    }
                                                }}
                                                value={state}
                                                isDisabled={loginUseType == 'doctorpersona' ? true : false}

                                            /> :
                                            <Dropdown
                                                items={states}
                                                value={state}
                                            />
                                    }

                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">City/Town <span className='requiredFld'> * </span></label>
                                    {/* <p>{town}  {towns.length}   {JSON.stringify(towns)}</p> */}
                                    {
                                        towns.length ?
                                            <Dropdown
                                                items={towns}
                                                onSelect={(item) => {
                                                    if (item) {
                                                        let _registration = this.state.registration
                                                        _registration.address["town"] = item.name
                                                        this.setState({ registration: _registration })
                                                        //console.log(item, "item")
                                                    }
                                                }}
                                                value={town}
                                                isDisabled={loginUseType == 'doctorpersona' ? true : false}

                                            /> :
                                            <Dropdown
                                                items={towns}
                                                value={town}
                                            />
                                    }

                                </div>
                            </div>

                            <div className="align-items-center mt-5">
                                <div className="reg-text-ft">
                                    <h3>Doctor Details</h3>
                                    <p className='text-red'>(Note: Dr. details are available on the Prescription)</p>


                                </div>
                                <div className="know-more-text mb-0">


                                </div>
                            </div>

                            <div className='row'>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">State <span className='requiredFld'> * </span></label>
                                    {
                                        statesDoctor.length ?
                                            <Dropdown
                                                items={statesDoctor}
                                                onSelect={(item) => {
                                                    if (item) {
                                                        let _registration = this.state.registration
                                                        _registration["drState"] = item.name
                                                        _registration["drCity"] = ""
                                                        this.setState({ registration: _registration })
                                                        //console.log(item, "item");
                                                        this.populateTownsDoctor(item.countryCode, item.isoCode)
                                                    }
                                                }}
                                                value={drState}
                                                isDisabled={loginUseType == 'doctorpersona' ? true : false}

                                            /> :
                                            <Dropdown
                                                items={statesDoctor}
                                                value={drState}
                                            />
                                    }

                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">City/Town <span className='requiredFld'> * </span></label>
                                    {/* <p>{town}  {towns.length}   {JSON.stringify(towns)}</p> */}
                                    {
                                        townsDoctor.length ?
                                            <Dropdown
                                                items={townsDoctor}
                                                onSelect={(item) => {
                                                    if (item) {
                                                        let _registration = this.state.registration
                                                        _registration["drCity"] = item.name
                                                        this.setState({ registration: _registration })
                                                        //console.log(item, "item")
                                                    }
                                                }}
                                                value={drCity}
                                                isDisabled={loginUseType == 'doctorpersona' ? true : false}

                                            /> :
                                            <Dropdown
                                                items={townsDoctor}
                                                value={drCity}
                                                isDisabled={loginUseType == 'doctorpersona' ? true : false}
                                            />
                                    }

                                </div>
                                <div className="col-md-4 mb-3 for-apper-pt">

                                    <label htmlFor className="form-label lvl-clr-hd">Pin Code<span className='requiredFld'> * </span></label>
                                    <input type='number' onInput={(e) => e.target.value = e.target.value.slice(0, 6)} value={drPin} onChange={(event) => this.changeValDoctor(event)} name="drPin" id className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} placeholder />
                                </div>
                            </div>
                            <div className="row">
                                {/* <div className="col-md-4 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Dr. Name <span className='requiredFld'> * </span></label>

                                    <div className='align-items-center'>
                                       
                                        <input
                                            type="text"
                                            value={drName}
                                            onChange={(event) => this.changeValDoctorName(event)}
                                            name='drName'
                                            id
                                            className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`}
                                            readOnly={loginUseType == 'doctorpersona' ? true : false}
                                            placeholder="Enter doctor's name"
                                        />
                                    </div>
                                </div> */}
                                {/* <div className="col-md-5 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Dr. Name <span className='requiredFld'> * </span></label>

                                    <div className='align-items-center'>

                                        <div className="dropdown-container" style={{ position: 'relative' }}>
                                            <input
                                                type="text"
                                                value={drName}
                                                name="drName"
                                                onChange={(event) => this.changeValDoctorName(event)}
                                                onClick={this.toggleDropdown}
                                                placeholder="Enter doctor's name"
                                                className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`}
                                            />

                                          
                                            {showDropdown && dropDownDoctor.length > 0 && (
                                                <ul className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: '0',
                                                    display: 'block',
                                                    width: '100%',
                                                    border: '1px solid #ddd',
                                                    maxHeight: '150px',
                                                    overflowY: 'auto',
                                                    backgroundColor: 'white',
                                                    listStyle: 'none',
                                                    padding: 0,
                                                    margin: 0
                                                }}>
                                                    {dropDownDoctor.length > 0 ? (
                                                        dropDownDoctor.map((doctor, index) => (
                                                            <li
                                                                key={index}
                                                                onClick={() => this.selectOption(doctor)}
                                                                style={{ padding: '8px', cursor: 'pointer' }}
                                                            >
                                                                {doctor.doctorName} - {doctor.doctorSpeciality}
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <li style={{ padding: '8px', color: 'gray' }}>No results found</li>
                                                    )}
                                                </ul>
                                            )}
                                        </div>



                                    </div>
                                </div> */}

                                <div className="col-md-5 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Dr. Name <span className='requiredFld'> * </span></label>

                                    <div className='align-items-center'>

                                        <div className="dropdown-container" style={{ position: 'relative' }}>
                                            <input
                                                type="text"
                                                value={drName}
                                                name="drName"
                                                onChange={(event) => this.changeValDoctorName(event)}
                                                onClick={this.toggleDropdown}
                                                placeholder="Enter doctor's name"
                                                className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`}
                                                readOnly={loginUseType == 'doctorpersona' ? true : false}
                                                style={{ paddingRight: '30px' }} // Space for the icon
                                            />

                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px', // Space between the icon and input edge
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    pointerEvents: 'none', // Makes the icon non-interactable
                                                    fontSize: '16px', // Adjust size as needed
                                                    color: '#aaa'
                                                }}
                                            >
                                                ▼
                                            </span>
                                            {this.state.showLoader && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: '0',
                                                    width: '100%',
                                                    backgroundColor: 'white',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                    border: '1px solid #ddd'
                                                }}>
                                                    Loading...
                                                </div>
                                            )}

                                            {/* Render dropdown options */}
                                            {!this.state.showLoader && showDropdown && dropDownDoctor.length > 0 && (
                                                <ul className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: '0',
                                                    display: 'block',
                                                    width: '100%',
                                                    border: '1px solid #ddd',
                                                    maxHeight: '150px',
                                                    overflowY: 'auto',
                                                    backgroundColor: 'white',
                                                    listStyle: 'none',
                                                    padding: 0,
                                                    margin: 0
                                                }}>
                                                    {dropDownDoctor.length > 0 ? (
                                                        dropDownDoctor.map((doctor, index) => (
                                                            <li
                                                                key={index}
                                                                onClick={() => this.selectOption(doctor)}
                                                                style={{ padding: '8px', cursor: 'pointer' }}
                                                            >
                                                                {doctor.doctorName} - {doctor.doctorSpeciality}
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <li style={{ padding: '8px', color: 'gray' }}>No results found</li>
                                                    )}
                                                </ul>
                                            )}

                                            {!this.state.showLoader && showDropdown && dropDownDoctor.length === 0 && (
                                                <ul className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: '0',
                                                    display: 'block',
                                                    width: '100%',
                                                    border: '1px solid #ddd',
                                                    backgroundColor: 'white',
                                                    listStyle: 'none',
                                                    padding: 0,
                                                    margin: 0
                                                }}>
                                                    <li style={{ padding: '8px', color: 'gray' }}>No results found</li>
                                                </ul>
                                            )}


                                        </div>



                                    </div>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">Mobile Number <span className='requiredFld'> * </span>
                                    </label>
                                    <input type="text" value={drmobileno} onChange={(event) => this.setNumber(event)} name="drmobileno" id className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} onInput={(e) => e.target.value = e.target.value.slice(0, 10)} placeholder />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Dr. Registration Number<span className='requiredFld'> * </span></label>
                                    <input type="text" value={drRegistrationNo} onChange={(event) => this.changeVal(event)} name='drRegistrationNo' id className={loginUseType == 'doctorpersona' ? `form-control inpt_brdr_colr field-readonly` : `form-control inpt_brdr_colr`} readOnly={loginUseType == 'doctorpersona' ? true : false} placeholder />
                                </div>

                            </div>


                            <div className=" mt-4 mb-4">
                                <input
                                    type="file"
                                    ref={this.fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={this.handleFileChange}
                                    onClick={(event) => {
                                        event.target.value = null
                                    }}

                                />
                                <button type="button" className="upld-prscrbtn-pt" id onClick={this.handleButtonClick}>
                                    {this.state.imagename ? "Change Your Prescription" : "Upload Your Prescription"}
                                </button>
                                <p style={{ fontSize: 11, paddingTop: 10, textAlign: 'right', color: "#0a4f73", marginRight: 5 }}> Prescription needs to be uploaded in either jpeg, png and pdf format within a maximum limit of 25 MB <span className='requiredFld'> * </span></p>

                                {fileUploadError && <div style={{ color, textAlign: 'right', marginRight: 20 }}>{fileUploadError}</div>}
                                {
                                    image && imagename && imagename.split('.').pop().toLowerCase() !== 'pdf' ?
                                        <div className="col-md-4 col-upload-image">
                                            <div className="upload-image-box" onClick={this.toggleLightbox}>
                                                <img
                                                    className="prescriptionimage"
                                                    src={image ? image : `${config.serviceUrl}/pres-images/${this.props.customer.prescription.filepath}`}
                                                    alt="Selected"
                                                />
                                            </div>
                                            {openLightbox && (
                                                <Lightbox
                                                    medium={image ? image : `${config.serviceUrl}/pres-images/${this.props.customer.prescription.filepath}`}
                                                    large={image ? image : `${config.serviceUrl}/pres-images/${this.props.customer.prescription.filepath}`}
                                                    alt="Selected Image"
                                                    onClose={this.toggleLightbox}
                                                />
                                            )}
                                        </div> :
                                        (
                                            image ? (
                                                <div style={{ height: '400px' }}>
                                                    <PdfViewerWithPlugin pdfFile={image ? image : this.fetchPdfAndConvertToBase64(`${config.serviceUrl}/pres-images/${this.props.customer.prescription.filepath}`)} />
                                                </div>
                                            ) : (
                                                <p>No file selected</p>
                                            )
                                        )

                                }
                                {
                                    image &&
                                    <button type="button" style={{ width: '200px' }} className="btn btn-white form-control upload-btn clear-sec-btn me-2 mt-4" onClick={() => {
                                        this.setState({ image: null, imagename: "", fileUploadError: "" })
                                    }}>
                                        Clear Selection
                                    </button>
                                }

                                {this.state.imagename != "" && <p>Selected file: {this.state.imagename}</p>}
                            </div>


                            <div className="row mt-4">
                                <div className='col-md-1 checkboxstyle'>
                                    <input type="checkbox" className={loginUseType == 'doctorpersona' ? `form-label clickdisable` : `form-label`} onChange={this.handleConsentCheckbox} checked={isChecked} />
                                </div>
                                <div className='col-md-10 consenttext' >
                                    <p>I consent to the sharing of my personal data & agreed to the policies mentioned on portal for the purpose of purchasing medicinal products. <Link to="/concent" target='_blank' className="privacy-policy-text me-2">Click Here</Link></p>
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className='col-md-6'>
                                    <div className="btn-home">
                                        <a href="javascript:void(0);" onClick={this.goBackPrevious}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                                            Back
                                        </a>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className="end-bck-btn-pt">
                                        <div className="">
                                            <button type="button" className="next-btn-crcl" id onClick={() => this.next('saveandproceed')}>
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                </section>
                {/*myown-login-part-end-----------*/}
                <CustomerFooter />
            </div>
        )

    }

}

const mapDispatchToProps = (dispatch) => {
    return {
        // dispatching plain actions
        setCustomer: (customer) => dispatch(CustomerAction.setCustomer(customer)),
        setConsentCheckbox: (consentValue) => dispatch(CustomerAction.setConsentCheckbox(consentValue)),
        setPagename: (pagename) => dispatch(CustomerAction.setPagename(pagename)),
        setDoctorPersona: (doctorPersonaDetails) => dispatch(DoctorPersonaAction.setDoctorPersona(doctorPersonaDetails))
    }
}

// const mapStateToProps = (state) => {
//     return {
//         // dispatching plain actions
//         CustomerReducer: state.CustomerReducer,
//         CommonReducer: state.CommonReducer,
//         CallCenterReducer: state.CallCenterReducer
//     }
// }

const mapStateToProps = ({ CustomerReducer, CallCenterReducer, CommonReducer, AdminReducer, DoctorPersonaReducer }) => {
    const { customer } = CustomerReducer
    const { callcenterdetails, storeSearchData, callcentercustomer } = CallCenterReducer
    const { summaryDetails, userType } = CommonReducer
    const { admin } = AdminReducer
    const { doctorPersonaDetails } = DoctorPersonaReducer
    console.log(customer, 123);
    console.log(storeSearchData, 123456);
    return {
        // dispatching plain actions
        // OrderListReducer: state.OrderListReducer,
        customer,
        callcenterdetails,
        summaryDetails,
        storeSearchData,
        callcentercustomer,
        admin,
        userType,
        doctorPersonaDetails
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Common(RegistrationDetails)))